// extracted by mini-css-extract-plugin
module.exports = {"newsCard":"css_newsCard__3OmZy","aggiungiNewsCard":"css_aggiungiNewsCard__3rHhe","createNewsButton":"css_createNewsButton__1Eyew"};